/* global moment angular swal _*/

import './style.less';
import AdminEmployeesModalActivityController from 'modals/employeesActivities';
import adminEmployeesModalActivityTemplate from 'modals/employeesActivities/index.html';
import AdminEmployeesModalCourseController from 'modals/employeesCourses';
import adminEmployeesModalCourseTemplate from 'modals/employeesCourses/index.html';
import AdminEmployeesModalTrackController from 'modals/employeesTracks/';
import adminEmployeesModalTrackTemplate from 'modals/employeesTracks/index.html';
import { get } from 'lodash';

export default function(
  $q,
  $log,
  $filter,
  $state,
  $stateParams,
  $sce,
  ApiClass,
  RegulatorClass,
  UserClass,
  $uibModal,
  ProfileClass
) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;

  const licenseArr = [];
  let firmEmployeesArr = [];

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.tableHeaders = [
    {
      title: 'Last',
      class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1'
    },
    {
      title: 'First',
      class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1'
    },
    {
      title: 'Licenses',
      class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1'
    },
    {
      title: 'Department',
      class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2'
    },
    {
      title: 'Practice Area',
      class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2'
    },
    {
      title: 'Level',
      class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2'
    },
    {
      title: 'Location',
      class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1'
    },
    {
      title: 'Permission',
      ngClass: 'hideMobile',
      class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1',
      tooltip: 'roleKey'
    }
  ];

  vm.uncheckLevelRadio = (ngModel, selected) => {
    if (ngModel.levelClicked === selected) {
      ngModel.levelSelected = undefined;
      ngModel.levelClicked = undefined;
    } else {
      ngModel.levelClicked = selected;
    }
  };

  vm.saveCategory = (employee, catSelected, category, open, id) => {
    const obj = {};
    if (catSelected.length === 0) return;
    const catSubmitInfo = catSelected.filter(({ checked }) => checked).map(cat => cat[id]);

    obj[category] = catSubmitInfo;

    vm.laddaStatus[category] = true;
    ApiClass.usersIdPatch({ id: employee.profile_uid }, obj)
      .then(() => {
        employee[category] = catSubmitInfo;
        vm.laddaStatus[category] = false;
        employee[open] = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.cancelCategory = (employee, filteredEmployees, resetName, open, resetToData, id) => {
    for (let i = 0; i < filteredEmployees.length; i++) {
      if (filteredEmployees[i].profile_uid === employee.profile_uid) {
        for (let j = 0; j < filteredEmployees[i][resetName].length; j++) {
          filteredEmployees[i][resetName][j].checked = false;
          if (employee[resetToData] && employee[resetToData].indexOf(filteredEmployees[i][resetName][j][id]) > -1) {
            employee[resetName][j].checked = true;
          }
        }
      }
    }
    employee[open] = false;
  };

  vm.updateLevel = (employee, update, levelSelected) => {
    if (!update) {
      employee.levelSelected = angular.copy(employee.level);
      employee.levelClicked = angular.copy(employee.level);
      return (employee.levelOpen = false);
    }
    vm.laddaStatus.level = true;
    ApiClass.usersIdPatch({ id: employee.profile_uid }, { level: levelSelected })
      .then(() => {
        vm.laddaStatus.level = false;
        employee.level = angular.copy(levelSelected);
        employee.levelOpen = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.updateRole = (employee, update) => {
    if (!update) {
      employee.rolesSelected.admin.checked = angular.copy(employee.admin);
      employee.rolesSelected.author.checked = angular.copy(employee.author);
      return (employee.rolesOpen = false);
    }
    ApiClass.usersIdPatch(
      { id: employee.profile_uid },
      {
        profile_uid: employee.profile_uid,
        admin: employee.rolesSelected.admin.checked,
        author: employee.rolesSelected.author.checked,
        team_leader: employee.rolesSelected.team_leader.checked,
        event_coordinator: employee.rolesSelected.event_coordinator.checked
      }
    )
      .then(() => {
        employee.admin = angular.copy(employee.rolesSelected.admin.checked);
        employee.author = angular.copy(employee.rolesSelected.author.checked);
        employee.team_leader = angular.copy(employee.rolesSelected.team_leader.checked);
        employee.event_coordinator = angular.copy(employee.rolesSelected.event_coordinator.checked);
        employee.rolesOpen = false;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.onClickSelectAll = function(selectAll) {
    vm.firmEmployees.forEach(user => (user.selected = selectAll));
    vm.updateSelected();
  };

  vm.updateSelected = function() {
    vm.selectedEmployees = vm.firmEmployees.filter(employee => employee.selected);
    vm.updateUserReportParams();
  };

  vm.assignActivity = function(selectedEmployees) {
    if (vm.selectedEmployees.length === 0) {
      return swal('Error', 'Please Select At Least One Employee', 'error');
    }
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalActivityTemplate,
      controller: AdminEmployeesModalActivityController,
      resolve: {
        selectedEmployees: () => {
          return selectedEmployees;
        }
      }
    });
  };

  vm.assignCourse = function(selectedEmployees) {
    if (vm.selectedEmployees.length === 0) {
      return swal('Error', 'Please Select At Least One Employee', 'error');
    }
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalCourseTemplate,
      controller: AdminEmployeesModalCourseController,
      resolve: {
        selectedEmployees: () => {
          return selectedEmployees;
        }
      }
    });
  };

  vm.assignTrack = function(selectedEmployees) {
    if (vm.selectedEmployees.length === 0) return swal('Error', 'Please Select At Least One Employee', 'error');
    $uibModal.open({
      backdrop: true,
      size: 'lg',
      template: adminEmployeesModalTrackTemplate,
      controller: AdminEmployeesModalTrackController,
      resolve: {
        selectedEmployees: function() {
          return selectedEmployees;
        }
      }
    });
  };

  vm.filterToggle = () => {
    vm.viewFilter = !vm.viewFilter;
  };

  vm.setUserId = function(user_id) {
    vm.roleEnable = true;
    vm.user_id = user_id;
  };

  vm.pageChanged = page => {
    $log.log('Page changed to: ' + vm.currentPage);
    const search = {
      ...$stateParams,
      page,
      archived: true
    };

    vm.setSearch(search);
  };

  vm.pageSizeChanged = pageSize => {
    const search = {
      ...$stateParams,
      pageSize,
      page: 1,
      archived: true
    };

    vm.setSearch(search);
  };

  vm.pageSortChanged = sortType => {
    const search = {
      ...$stateParams,
      sortType,
      page: 1,
      archived: true
    };

    vm.setSearch(search);
  };

  vm.setSearch = search => {
    $state.go('.', search, { notify: true, reload: true });
  };

  vm.updateUserReportParams = () => {
    vm.userReportParams = {
      ...vm.userSearchFilters,
      profile_uids: vm.selectAll ? [] : vm.selectedEmployees.map(({ profile_uid }) => profile_uid),
      archived: vm.archived,
    };
  };

  function activate() {
    vm.useDepartment = {};
    vm.laddaStatus = {};
    vm.useTeam = {};
    vm.useLicense = {};
    vm.useLevel = {};
    vm.usePractice = {};
    vm.useLocation = {};
    vm.profileUid = UserClass.profile_uid;
    vm.selectedDepartment = $state.params.department;
    vm.selectedLicense = $state.params.license;
    vm.complianceFilterBol = false;
    vm.viewFilter = false;
    vm.resultsQueried = false;
    vm.selectedEmployees = [];
    vm.userReportParams = {};
    vm.archived = true;
    vm.profileUid = UserClass.profile_uid;
    vm.searchText = '';
    vm.roleKey = $sce.trustAsHtml('<i class="fa fa-briefcase"> Admin</i><br><i class="fa fa-edit"> Author</i>');

    ApiClass.companiesIdTypeGet({ manage: true, id: company_id, type: 'tagCategories' })
      .then(({ data: { items }}) => {
        const tagData = items.find(item => item.tagCategory.name === "Employee Status");
        const TERMINATED_TAG = tagData ? Object.values(tagData.tags).find(v => v.name === "T").uuid : undefined;
        vm.archived = !($stateParams.tags || []).some(tag => tag === TERMINATED_TAG);

        const userQuery = {
          ...$stateParams,
          pagination: {
            page: $stateParams.page,
            pageSize: $stateParams.pageSize,
            sortType: $stateParams.sortType
          },
          archived: vm.archived,
        };

        vm.updateUserReportParams();

        $q.all([
          RegulatorClass.loadRegulators(),
          ApiClass.usersPost({}, userQuery, {
            queryParams: { 'include:licenses': true, 'filter:latest': true, manage: true }
          }),
          ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
            queryParams: {
              departments: true,
              levels: true,
              locations: true,
              practices: true,
              certifications: true
            }
          })
        ])
          .then(([{ objCurrent }, profiles, { data: { departments, levels, locations, practices, certifications } }]) => {
            const {
              data: { items = [], licenses = [], pagination = {} }
            } = profiles;
    
            const compliance = licenses;
            const employees = items;
            const { count, page, pageSize, sortType } = pagination;
    
            vm.totalItems = count;
            vm.currentPage = page;
            vm.itemsPerPage = pageSize;
            vm.sortType = sortType;
    
            firmEmployeesArr = employees || [];
            const firmEmployeesDict = _.keyBy(employees, 'profile_uid');
            const deptArr = departments;
            const deptDict = _.keyBy(departments, 'id');
            const practiceArr = practices;
            const practiceDict = _.keyBy(practices, 'practice_id');
            const locationArr = locations;
            const locationDict = _.keyBy(locations, 'location_id');
            const regulatorDict = objCurrent;
            const levelDict = _.keyBy(levels, 'level_id');
            vm.certifications = certifications;
            vm.regDict = regulatorDict;
            vm.deptDict = deptDict;
            vm.levelDict = levelDict;
            vm.practiceDict = practiceDict;
            vm.locationDict = locationDict;
            vm.departmentGroup = deptArr;
            vm.levelGroup = levels;
            vm.practiceGroup = practiceArr;
            vm.locationGroup = locationArr;
            vm.locationObj = locationDict;
            vm.practiceObj = practiceDict;
            vm.levelObj = levelDict;
            vm.deptObj = deptDict;
            vm.regulatorDict = regulatorDict;
    
            if (compliance.length > 0) {
              compliance.forEach(license => {
                if (!regulatorDict[license.reg_id]) return;
    
                const employee = firmEmployeesDict[license.profile_uid];
    
                if (employee) {
                  employee.licenses = employee.licenses || [];
                  employee.licenses.push(license.reg_id);
                }
    
                if (new Date(Date.now()) > new Date(license.cycle_date)) return;
    
                license.profile = employee;
    
                license.licenseProgress = $filter('Progress')(
                  license.applied.total,
                  regulatorDict[license.reg_id].cycle_total
                ).toFixed(2);
    
                license.cyc_time = moment(new Date(license.cycle_date))
                  .diff(moment(new Date(Date.now())), 'months', true)
                  .toFixed(2);
    
                licenseArr.push(license);
              });
            }
    
            if (firmEmployeesArr.length > 0) {
              for (let i = 0; i < firmEmployeesArr.length; i++) {
                const employee = firmEmployeesArr[i];
    
                if (firmEmployeesDict[employee.profile_uid] === undefined) return;
                let user_profile = firmEmployeesDict[employee.profile_uid];
    
                if (user_profile.licenses === undefined) user_profile.licenses = [];
    
                user_profile.deptSelected = angular.copy(deptArr);
                user_profile.deptOpen = false;
                user_profile.deptSelected.forEach((dept, index) => {
                  if (user_profile.department && user_profile.department.length > 0) {
                    if (Array.isArray(user_profile.department)) {
                      user_profile.deptSortName = get(deptDict[user_profile.department[0]], 'name', undefined);
    
                      user_profile.department.forEach(department => {
                        if (department === dept.id) user_profile.deptSelected[index].checked = true;
                      });
                    } else {
                      user_profile.deptSortName = get(deptDict[user_profile.department], 'name', undefined);
                      if (user_profile.department === dept.id) user_profile.deptSelected[index].checked = true;
                    }
                  }
                });
    
                user_profile.practiceSelected = angular.copy(practiceArr);
                user_profile.practiceOpen = false;
                user_profile.practiceSelected.forEach((loc, index) => {
                  if (user_profile.practices && user_profile.practices.length > 0) {
                    user_profile.practiceSortName = get(practiceDict[user_profile.practices[0]], 'name', undefined);
    
                    user_profile.practices.forEach(practiceId => {
                      if (practiceId === loc.practice_id) {
                        user_profile.practiceSelected[index].checked = true;
                      }
                    });
                  }
                });
    
                user_profile.locationSelected = angular.copy(locationArr);
                user_profile.locationOpen = false;
                user_profile.locationSelected.forEach((loc, index) => {
                  if (
                    user_profile.locations &&
                    locationDict[user_profile.locations[0]] &&
                    user_profile.locations.length > 0
                  ) {
                    user_profile.locationSortName = get(locationDict[user_profile.locations[0]], 'name', undefined);
    
                    user_profile.locations.forEach(locationId => {
                      if (locationId === loc.location_id) {
                        user_profile.locationSelected[index].checked = true;
                      }
                    });
                  }
                });
    
                user_profile.levelSelected = angular.copy(user_profile.level);
                user_profile.levelClicked = angular.copy(user_profile.level);
                user_profile.levelOpen = false;
    
                user_profile.roleOpen = false;
                user_profile.rolesSelected = {
                  admin: { name: 'Admin', icon: "<i class='fa fa-briefcase'></i>", checked: false },
                  author: { name: 'Author', icon: "<i class='fa fa-pencil-square-o'></i>", checked: false },
                  team_leader: { name: 'Team Manager', icon: "<i class='fa fa-users'></i>", checked: false },
                  event_coordinator: { name: 'Event Coordinator', icon: "<i class='fa fa-calendar'></i>", checked: false }
                };
                if (user_profile.admin) user_profile.rolesSelected.admin.checked = true;
                if (user_profile.author) user_profile.rolesSelected.author.checked = true;
                if (user_profile.team_leader) user_profile.rolesSelected.team_leader.checked = true;
                if (user_profile.event_coordinator) user_profile.rolesSelected.event_coordinator.checked = true;
              }
            }
    
            vm.licenseArr = licenseArr;
            vm.firmEmployees = firmEmployeesArr;
            vm.firmEmployeesDict = _.keyBy(firmEmployeesArr, 'profile_uid');
            vm.resultsQueried = true;
          })
          .catch(error => {
            $log.error(error);
            throw error;
          });
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/employees/controller.js